<ion-footer *ngIf="variant === 'login'" class="ion-no-border login-footer">
  <ion-toolbar>
    <p class="ion-no-margin ion-text-center footer-text">
      © 2026 INDAP v{{ version }}. Todos los derechos reservados.
    </p>
  </ion-toolbar>
</ion-footer>

<footer *ngIf="variant === 'app'" class="app-contenido-footer">
  <p class="ion-no-margin ion-text-center footer-text app-contenido-footer__text">
    © 2026 INDAP v{{ version }}. Todos los derechos reservados.
  </p>
</footer>
